import React from 'react';

import { Modal } from './Modal';
import '../style/map.scss';

export const SigmetModal = ({ isOpen, handleClose, data }) => {
  const items = data?.items?.length
    ? data.items
    : [{ hazard: data?.hazard, rawText: data?.rawText }];

  return (
    <Modal isOpen={isOpen} handleClose={handleClose}>
      <div className="map-modal-container">
        {items.map((item, index) =>
          item.kind === 'area' ? (
            <div className="map-modal-paragraph" key={`area-${index}`}>
              <p>{item.area?.sHeader}</p>
              <p>{item.area?.sCat}</p>
              <span style={{ whiteSpace: 'pre-wrap' }}>{item.area?.sBody}</span>
            </div>
          ) : (
            <div className="map-modal-paragraph" key={`sigmet-${index}`}>
          <p>HAZARD</p>
              <span style={{ textAlign: 'center' }}>{item.hazard}</span>
          <p>SIGMET RAW TEXT</p>
              <span style={{ whiteSpace: 'pre-wrap' }}>{item.rawText}</span>
        </div>
          )
        )}
      </div>
    </Modal>
  );
};
